import { render, staticRenderFns } from "./BuyerCampaignDetails.vue?vue&type=template&id=95aba9c8&scoped=true"
import script from "./BuyerCampaignDetails.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyerCampaignDetails.vue?vue&type=style&index=0&id=95aba9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aba9c8",
  null
  
)

export default component.exports